import { Box, Card, CardProps, Flex, Link, Typography, useModal } from "@xcorejs/ui";
import { useLayout } from "xcore";
import { Rental } from "xcore/types";
import { RentalFinderModal } from "components/Modals";
import Richtext from "design-system/Richtext";

export type RentalCardProps = {
  rental: Pick<Rental, "values">;
  showDetail?: string;
  getDirections?: string;
} & CardProps;

const RentalCard = ({ rental, showDetail, getDirections, ...props }: RentalCardProps) => {
  const [showDetails] = useModal(RentalFinderModal, { rental, getDirections });
  const { stringify } = useLayout();

  return (
    <Card
      variant="outline"
      body={
        <Flex flexDirection="column" width="100%" height="100%" justifyContent="space-between">
          <Box>
            <Typography variant="h4" color="#1E1E1E">
              {stringify(rental.values.title)}
            </Typography>
            <Box maxHeight="10rem" overflow="hidden" style={{ whiteSpace: "pre-wrap" }}>
              <Richtext value={rental.values.address} />
            </Box>
          </Box>

          <Typography mt="2rem">
            <Link v="underline" maxWidth="100%" onClick={() => showDetails({})}>
              {showDetail ?? "Show detail"}
            </Link>
          </Typography>
        </Flex>
      }
      _body={{
        padding: "3rem",
      }}
      boxShadow="none"
      height="auto"
      justifyContent="space-between"
      maxWidth="none"
      {...props}
    />
  );
};

export default RentalCard;
